
function alertBar() {
    const alertBar = document.querySelector('.announcementBar');
    const closeButton = document.querySelector('.announcementBar__close');

    let expiredTime = 86400; // 1 day in seconds

    if (alertBar) {
        // On close, remove alertBar from DOM and set cookie that expires in 1 day
        closeButton.addEventListener("click", function() {
            alertBar.parentNode.removeChild(alertBar);
            document.cookie = "alertBar=1; max-age=" + expiredTime + "; path=/";
        });
    }

}

function headerPin() {

    const headerEl = document.querySelector(".site-header");
    const headerObserver = new IntersectionObserver(
        ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
        { threshold: [1] }
    );

    headerObserver.observe(headerEl);

}

function anchorScroll() {
    document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
          let target = document.querySelector(this.hash) || document.querySelector(`[name=${this.hash.slice(1)}]`);
          if (target) {
            e.preventDefault();
            window.scrollTo({ top: target.offsetTop - 76, behavior: 'smooth' });
            
            target.tabIndex = -1;
            target.focus({preventScroll: true});
          }
        }
      });
    });
  }
  

/**
 * Function to run when this module is called from site.js
 */
const init = () => {
    alertBar();
    headerPin();
    anchorScroll();
};

export default init;
